<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Créer' }} un groupe métier</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Nom du groupe métier <b>(obligatoire)</b>
                    <InputUniqChecker
                        class="stretch"
                        placeholder="Renseignez un nom de groupe métier"
                        v-model="value.name"
                        required
                        :err-msg="`Un groupe métier nommé ${value.name} existe déjà`"
                        url="/api/check/businessGroup/name"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Utilisateurs
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez les utilisateurs"
                        :options="users"
                        :multiple="true"
                        v-model="value.users"
                    />
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="default stretch" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomButton from './../Button';
import CustomSelect from './../Select';
import InputUniqChecker from './../InputUniqChecker';

export default {
    props: ['value', 'users'],
    components: {
        Modal,
        CustomButton,
        CustomSelect,
        InputUniqChecker,
    },
};
</script>

<style lang="scss"></style>
